import { render } from "./ServiceOnlyView.vue?vue&type=template&id=55dc6526&scoped=true"
import script from "./ServiceOnlyView.vue?vue&type=script&lang=js"
export * from "./ServiceOnlyView.vue?vue&type=script&lang=js"

import "./ServiceOnlyView.vue?vue&type=style&index=0&id=55dc6526&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55dc6526"]])

export default __exports__